import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import user from './modules/user.js'
import communal from './modules/communal.js'

const store = new Vuex.Store({
	modules: {
		user,
		communal
	}
})

export default store